const cardColumns = document.querySelectorAll('.js-card-column-height');
let maxHeight = 0;
cardColumns.forEach(column => {
    const height = column.offsetHeight;
    if (height > maxHeight) {
        maxHeight = height;
    }
});
cardColumns.forEach(column => {
    column.style.height = `${maxHeight}px`;
});

window.addEventListener('resize', () => {
    if (window.innerWidth >= 993) {
        maxHeight = 0;
        cardColumns.forEach(column => {
            column.style.height = 'auto'; // reset the height first
            const height = column.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        cardColumns.forEach(column => {
            column.style.height = `${maxHeight}px`;
        });
    } else {
        cardColumns.forEach(column => {
            column.style.height = 'auto';
        });
    }
});